import * as React from 'react';
import styled from 'styled-components';
import { TextInput } from '../../components/inputs/textInput/textInput';
import { Page } from '../page';
import { Button } from '../../components/buttons/button';
import { Cookies } from 'react-cookie';
import { authenticationService } from '../../utils/fetcher/authorise';
import  DelayRedirect  from '../../utils/delayRedirect';
import { PageWrapper, LoginWrapper, InputSeparator } from './login.styles';
import {AlertMesssage} from "../../components/blocks/alertMessage/alertMessage";

interface Props {
  cookies: Cookies;
}

interface State {
  login: string;
  password: string;
  token: string;
  hasError: boolean;
  showMessage: string;
}

export class LoginPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      login: '',
      password: '',
      token: '',
      hasError: false,
      showMessage: ''
    }
  }

  public render() {
    let redirect = <DelayRedirect to={'/'} delay={1000} />
    return (
      <Page title='Simplicity Login' tabNavigation={false}>
        <PageWrapper>
          <LoginWrapper>
            <TextInput
              placeholder='Login'
              value={this.state.login}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => this.setState({login: event.target.value})}
            />
            <InputSeparator />
            <TextInput
              placeholder='Password'
              type='password'
              value={this.state.password}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => this.setState({password: event.target.value})}
            />
            <InputSeparator />
            <Button onClick={this.authorize.bind(this)}>
              Login
            </Button>
            <AlertMesssage type={this.state.hasError ? 'error' : 'success'} message={this.state.showMessage}></AlertMesssage>
          </LoginWrapper>
        </PageWrapper>
        {this.state.token? redirect : ''}
      </Page>

    );
  }

  private authorize() {
    authenticationService.login(this.state.login, this.state.password).then(data => {
      if(data.status == 1) {
        this.setState({'token': data.token, 'showMessage':data.message, 'hasError':false});
      } else {
        this.setState({'token': '', 'showMessage':data.message, 'hasError':true});
      }
    });

  }
}
